export default __webpack_public_path__ + "static/banner-7-ede4e79409091e2b0254b18f69b959a8.jpg";